import script from "./CategoryFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFilter.vue?vue&type=style&index=0&id=676e3f8e&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676e3f8e"]])

export default __exports__